// extracted by mini-css-extract-plugin
export default {"container":"Protected_container__Xopqc"};